export default __webpack_public_path__ + "static/media/pc_step_2_En.f64a27b3.png";